module.exports = __webpack_public_path__ + "img/L4B.198fdf4f.jpg";